
import { mixins, Component } from 'nuxt-property-decorator';
import Icon from '../Icon.vue';
import ActionMixin from './ActionMixin';

@Component({
  components: {
    Icon,
  },
})
export default class ActionStatic extends mixins(ActionMixin) {
  get buttonClassNames() {
    return [
      { ...this.elementClassNames, '-disabled': this.disabled },
      `-${this.hierarchy} -${this.Sizes[this.size] || this.size}`,
    ];
  }
}
